
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components';
import { Button, IconButton, Skeleton, Tooltip, Typography } from '@mui/material';
import Title from '../custom/Title';
import DynamicFormNew, { TDynamicFieldProps, TField, getFormConfigDeepCopy, useDynamicForm } from '../forms/DynamicFormNew';
import { useNavigate, useParams } from 'react-router-dom';
import { TBilling, TPayment } from '../../Models/Billing';
import { TransactionContext } from '../../contexts/TransactionContext';
import { TBuySellStpeKeys } from '../_BuySell';
import { TBuyBackSectionKeys } from '../_BuyBack';
import { TJobWorkSectionKeys } from '../_JobWork';
import { TColumn, TStepsProps } from '../../Models/common';
import { NotificationContext } from '../../contexts/NotificationContext';
import { Delete, FileUpload, Info } from '@mui/icons-material';
import useService from '../../hooks/useService';
import { confirmBillingPayments, deleteBillingPayment, getLotDetails, recordBillingPayment, uploadFile, fetchBankDetails } from '../../services/Transactions';
import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import StepNavigation from '../custom/StepNavigation';
import { BANK_OPTIONS, CASH_TRANSACTION_LIMIT, CHARGE_TYPES, GRAIN_SKU, NUMBER_REGEX, PAN_CASH_LIMIT, PAN_LIMIT, STATES, STATES_CODES_CLIENT, TAX_TYPES, TRANSACTION_STATUS, TRANSACTION_TYPES } from '../../utils/constant';
import { CustomerContext } from '../../contexts/CustomerContext';
import Modal from '../Modals';
import CustomerPanUpload from '../_CustomerSetup/CustomerPanUpload';
import { ICustomerSummary } from '../../Models/Customer';
import { getCustomer } from '../../services/Customer';
import { formatDate, getFormattedCurrency, getPvcStateCode, getThreePointNumber, getTwoPointNumber } from '../../utils/helpers';
import BillingDetailsModal, { TBillingDetailsItem } from './BillingDetailsModal';
import { TOrderCharges } from '../../Models/Transactions';
import { TPvcCenterAddress } from '../../Models/PVC';
import DownloadInvoice from '../$Summary/DownloadInvoice';
import moment from 'moment';
import { sendOtpForEmployeeValidation } from '../../services/Customer';
import EmployeeValidationModal from '../Modals/EmployeeValidationModal';



export type TInboundProps = {
    nextSection: TBuySellStpeKeys | TBuyBackSectionKeys | TJobWorkSectionKeys,
    nextButtonLable: string;
    path: string
}


const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result ? reader.result.toString() : '')
        reader.onerror = (error) => reject(error)
    })


const UploadFile = (props: TDynamicFieldProps<TPayment>) => {
    const { config, formData, onChange, error } = props
    const { fieldName, label } = config;
    const [showValue, setShowValue] = useState<string | undefined>("");
    const { execute } = useService()
    const { notify } = useContext(NotificationContext);
    const { transactionInfo } = useContext(TransactionContext);
    const globalTransactionNumber = transactionInfo.globalTransactionNumber!;

    const uploadPaymentFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files?.length) return
        const file = e.target.files[0];
        const imageName = file.name;
        const base64File = await toBase64(file);
        const payload = {
            transactionType: transactionInfo.transactionType,
            globalTransactionNumber,
            image: base64File
        }
        const { data, error } = await execute(() => uploadFile(payload))
        if (!error) {
            notify('File Uploaded Successfully!');
            setShowValue(imageName);
            onChange(data?.docUrl)
            e.target.value = ''
        } else {
            notify('Something went wrong while uploading...', 'error');
        }
    }

    const clickHandler = () => {
        (document.querySelector('#paymentFileInput') as HTMLInputElement).click();
    }

    const getValue = () => formData[fieldName]

    return (
        <div>
            <div style={{ display: 'flex', gap: '10px' }}>
                <FileInput error={Boolean(error)} onClick={clickHandler}>
                    <FileLabel isFilled={Boolean(getValue())}>{label} text</FileLabel>
                    {showValue ? <span>{showValue}</span> : <></>}
                </FileInput>
                <Button
                    variant='contained'
                    onClick={clickHandler} >
                    <FileUpload />
                </Button>
                <input type='file' style={{ display: 'none' }} id='paymentFileInput'  onChange={(e) => uploadPaymentFileChange(e as any)} />
            </div>
            {error ? <span style={{ fontFamily: `"Roboto","Helvetica","Arial",sans-serif`, color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", lineHeight: "1.66", letterSpacing: "0.03333em", textAlign: "left", marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{error}</span> : <></>}
        </div>
    )
}


export const PAYMENT_COLUMNS: TColumn<TPayment & {actions:any}>[] = [
    {
        field: "id",
        headerName: "Payment Id",
        minWidth: 100
    },
    {
        field: "actions",
        headerName: "Actions",
        minWidth: 100,
    },
    {
        field: "amount",
        headerName: 'Amount',
        minWidth: 100,
    },
    {
        field: "paymentStatus",
        headerName: 'Status',
        minWidth: 100
    },
    {
        field: "paymentMethod",
        headerName: 'Payment Type',
        minWidth: 160
    },
    {
        field: "createdAt",
        headerName: 'Bill Date',
        minWidth: 150
    },
    {
        field: "paymentReferenceNumber",
        headerName: 'Payment Reference Number',
        minWidth: 160
    },
    {
        field: "proofOfPayment",
        headerName: 'Uploaded File',
        minWidth: 200
    },
    {
        field: "additionalDetails",
        headerName: 'Remarks',
        minWidth: 160
    }
]

export const BILLING_DETAILS_FIELDS = [
    {
        id: "id",
        label: "Billing No"
    },
    {
        id: 'currency',
        label: 'Currency'
    },
    {
        id: 'totalBill',
        label: 'Total Bill'
    },
    {
        id: 'totalPending',
        label: 'Total Pending'
    },
    {
        id: 'createdAt',
        label: 'Bill Date'
    },
    {
        id: 'status',
        label: 'Status'
    }
]

const PAYMENT_OPTIONS = [
    { value: "CASH", label: 'Cash' }, 
    { value: "TDS DEDUCTION", label: 'TDS Deduction' }, 
    { value: "NA TDS DEDUCTION", label: 'NA TDS DEDUCTION' }, 
    { value: "CHEQUE", label: 'Cheque' }, 
    { value: "BANKAC", label: 'Bank Account' }, 
    { value: "MISCELLANEOUS", label: 'MISCELLANEOUS' }, 
    { value: "UPI", label: "UPI" }, 
    { value: 'WALLET', label:'Pay By Wallet'},
    { value: 'CREDIT_CARD', label:'Credit Card'},
    { value: 'DEBIT_CARD', label:'Debit Card'},
    // { value: 'DEMAND_DRAFT', label:'Demand Draft'},
    // { value: 'DEMAT_ACCOUNT', label:'Demat Account'},
    // { value: 'HSBC_API', label:'HSBC API'},
    { value: 'IMPS', label:'IMPS'},
    { value: 'NEFT', label:'NEFT'},
    { value: 'RTGS', label:'RTGS'},
    { value: 'FREE_OF_CHARGE', label: 'Free Of Charge (FOC)'},
    { value: 'ONE CARD', label: 'One Card'},
    { value: 'EXCHANGE', label: 'EXCHANGE'}
]

export const BILLING_CONFIG: TField<TPayment>[] = [
    {
        fieldName: 'amount',
        isVisible: true,
        fieldType: 'number',
        label: 'Amount',
        fullWidth: false,
        validation: { required: true }
    },
    {
        fieldName: 'paymentMethod',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'Payment Method',
        fullWidth: false,
        validation: { required: true },
        options: [],
    },
    {
        fieldName: "proofOfPayment",
        isVisible: true,
        fieldType: "custom",
        label: "Upload File",
        fullWidth: false,
        validation: { required: false }
    },
    {
        fieldName: "paymentReferenceNumber",
        isVisible: true,
        fieldType: "text",
        label: "Payment Reference Number",
        fullWidth: false,
        validation: { required: true }
    },
    {
        fieldName: "cardLastDigits",
        isVisible: false,
        fieldType: "text",
        label: "Card Last 4 Digits",
        fullWidth: false,
        regexFilter: NUMBER_REGEX,
        validation:{
            minLength:4,
            maxLength:4
        }
    },
    {
        fieldName: 'bankName',
        isVisible: false,
        label: 'Bank Name',
        fieldType: 'autocomplete',
        options: [],
        fullWidth:false
    },
    {
        fieldName: "additionalDetails",
        isVisible: true,
        fieldType: "text",
        label: "Remarks",
        fullWidth: false
    }
]

const FileInput: (props: React.HTMLAttributes<HTMLDivElement> & { error: boolean }) => React.JSX.Element = styled.div`
    width: 100%;
    height: 40px;
    padding: 10px 18px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    border-radius: 4px;
    cursor: pointer;
    ${(props) => props.error ? `
        border: 1px solid red;
    `: `border: 1px solid var(--text_color_2);`}
`

const FileLabel: (props: React.HTMLAttributes<HTMLDivElement> & { isFilled: boolean }) => React.JSX.Element = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    font-size: 1rem;
    transform: translate(14px, 7px) scale(1);
    transform-origin: left;
    transition: 0.1s;
    background: white;
    padding: 0 5px;

    ${(props) => props.isFilled ? `
        transform: translate(14px, -12px) scale(0.75);
    `: ``}
`

const FormSkeleton = ({ rows }: { rows?: number }) => {
    rows = rows ? rows : 4
    return <div style={{
        width: '100%',
        display: 'flex',
        columnGap: '20px',
        flexWrap: 'wrap'
    }}>
        {Array(5).fill('_').map((_, i) => <Skeleton key={i + 'field_skeleton'} animation="wave" width='calc(50% - 20px)' height={75} />)}
    </div>
}


const Billing = (props: TStepsProps) => {
    const { path, nextButtonLable, nextSection, prevSection } = props
    const { execute, store } = useService()
    const { transactionsStore, customerStore, authStore, notificationStore } = store
    const { isEmployeeVerified, setIsEmployeeVerified } = useContext(TransactionContext);
    const { billingData, capturedSteps, setCapturedSteps, transactionInfo, payments, physicalOrder, meltingLot, pvcCenterDetails, setPayments } = transactionsStore
    const { notify, confirm } = notificationStore
    const { customerConfig ,customerAddresses} = customerStore
    const { pvcAddresses } = authStore
    const navigate = useNavigate()
    const [showPaymentForm, setShowPaymentForm] = useState<boolean>(true);
    const [showPanForm, setShowPanForm] = useState<ICustomerSummary | boolean>(false)
    const [showBillingModal, setShowBillingModal] = useState(false)
    const [isBankVisible, setIsBankVisible] = useState(false);
    const [openEmployeeValidationModal, setOpenEmployeeValidationModal] = useState(false);
    const [otpSentTo, setOtpSentTo] = useState('');

    const [loading, setLoading] = useState(false)
    const { id } = useParams()
    const [forceNavigate, setForceNavigate] = useState(false);

    const globalTransactionNumber = transactionInfo.globalTransactionNumber!;
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [pendingBillingFormData, setPendingBillingFormData] = useState<any>(null);

    const { registerForm, formData: data, setFormConfig, setFormData, setField } = useDynamicForm({ formConfig: getFormConfigDeepCopy(BILLING_CONFIG) });

    const getBankOptions = async () => {
        const { data, error } = await execute(() => fetchBankDetails({ transactionType: transactionInfo.transactionType }));

        if (!error && data) {
            setField('bankName', {
                options: data.map((item: any) => ({
                    value: item.bank_name,
                    label: item.bank_name
                }))
            })
        }
    }
    
    useEffect(() => {
        const tds = physicalOrder?.taxes?.filter(tax => tax.taxType === TAX_TYPES.TDS)[0]

        if (billingData.totalPending === 0) {
            setShowPaymentForm(false);
        }
        if (billingData.totalBill > PAN_LIMIT && customerConfig.kycStatus === 'I') {      // check
            notify(`Pan card required for amount above ${PAN_LIMIT}`, 'error')
            setShowPanForm(true);
        }

        // if (billingData.totalBill > PAN_CASH_LIMIT && customerConfig.kycStatus === 'I') {      
        //     setShowPanForm(true);
        //     return  notify(`Pan card required for amount above ${PAN_CASH_LIMIT}`, 'error')
        // }

        if(billingData.payments && tds && payments.filter(payment => payment.paymentMethod === 'TDS_SETTLEMENT').length === 0) {
            setPayments([ ...payments.map(payment => {
                return {
                    ...payment,
                    amount: getFormattedCurrency(payment.amount, true)
                }
            }), {
                id: '',
                billingNumber: '',
                paymentMethod: 'TDS_SETTLEMENT',
                createdAt: (billingData.createdAt as unknown as string),
                amount: getFormattedCurrency(-1 * tds.taxAmount, true),
                paymentStatus: 'PAID',
                paymentType: '',
                additionalDetails: '',
                proofOfPayment: '',
                paymentReferenceNumber: ''
            }]);
        }
        if(billingData.totalBill){
            let type_of_this=(typeof(billingData.totalBill));
            if(type_of_this!="string"){ 
                if(tds)  billingData.totalBill = ( billingData.totalBill - tds.taxAmount)   // adding TDS (since TDS is negative,so using - )
                billingData.totalBill=getFormattedCurrency( billingData.totalBill,true)
            }
        }
        if(billingData.totalPending){
            let type_of_this=(typeof(billingData.totalPending));
            if(type_of_this!="string"){ 
                billingData.totalPending=getFormattedCurrency( billingData.totalPending,true)
                }
        }
    }, [billingData])


    useEffect(() => {
        // const proofOfPayment = data.paymentMethod === "INTERNALADJUSTMENT"
        const proofOfPayment = ['INTERNALADJUSTMENT', 'FREE_OF_CHARGE'].includes(data.paymentMethod)
        const paymentReferenceNumber = [
            'BANKAC', 'UPI', 'CREDIT_CARD', 
            'DEBIT_CARD', 'DEMAND_DRAFT', 'DEMAT_ACCOUNT',
            'HSBC_API', 'IMPS', 'NEFT', 'RTGS', 'RAZORPAY'
        ].includes(data.paymentMethod)
        const additionalDetails = data.paymentMethod === "BANKAC"
        const showBankName = [
            'BANKAC', 'UPI', 'CREDIT_CARD', 'CHEQUE',
            'DEBIT_CARD', 'DEMAND_DRAFT', 'DEMAT_ACCOUNT',
            'HSBC_API', 'IMPS', 'NEFT', 'RTGS', 'RAZORPAY' ,'FREE_OF_CHARGE'
        ].includes(data.paymentMethod)
        const disableBankName = data.paymentMethod === 'HSBC_API'
        const cardLastDigits = ['DEBIT_CARD', 'CREDIT_CARD'].includes(data.paymentMethod)
        setIsBankVisible(showBankName)

        setFormConfig(prev => {
            return prev.map(field => {
                switch (field.fieldName) {
                    case "proofOfPayment":
                        return { ...field, validation: { required: proofOfPayment } };
                    case "paymentReferenceNumber":
                        return { ...field, validation: { required: paymentReferenceNumber } };
                    case "additionalDetails":
                        return { ...field, validation: { required: additionalDetails } }
                    case "bankName":
                        return { ...field, isVisible:showBankName, disabled:disableBankName, validation: { required:data.paymentMethod == "FREE_OF_CHARGE" || data.paymentMethod == "UPI"  ? false :  showBankName }}
                    case "cardLastDigits":
                        return { ...field, isVisible:cardLastDigits, validation:{...field.validation, required:cardLastDigits}}
                    default:
                        return field;
                }
            })
        })
        
        if(data.paymentMethod === 'HSBC_API') setFormData(prev => ({...prev, bankName:'HSBC'}))
    }, [data])

    const getBillingLineItems = () => {
        const pvcAddress = pvcAddresses[0]
        let customerAddressId = physicalOrder.shippingAddressId;
        let customerAddressCode;
        if (customerAddresses && customerAddresses?.length > 0) {
            for (let i = 0; i < customerAddresses.length; i++) {
                if (customerAddressId == customerAddresses[i].id)
                    customerAddressCode = customerAddresses[i].stateCode

            }
        }
        const intraState = customerAddressCode ? pvcAddress?.stateCode === customerAddressCode:true;
        let billingLineItems: TBillingDetailsItem[] = []

        // let mintedProducts: TBillingDetailsItem = {
        //     id: 'minted_product_charge',
        //     name: 'Minted Products',
        //     quantity:0,
        //     preTaxAmount:0,
        //     taxPercentage:3,
        //     totalAmount:0
        // } as TBillingDetailsItem

        physicalOrder.charges?.forEach(charge => {
            if (charge.chargeId === CHARGE_TYPES.MAKING_CHARGE) {
                if ([TRANSACTION_TYPES.BUY_SELL, TRANSACTION_TYPES.JOB_WORK].includes(transactionInfo.transactionType)) {
                    billingLineItems.push({
                        id: charge.id,
                        name: `Making Charges for ${charge.additionalInformation?.product.name}(${charge.additionalInformation?.product.skuId})`,
                        quantity: charge.quantity,
                        unitPrice: getFormattedCurrency(charge.unitPrice),
                        totalAmount: getFormattedCurrency(transactionInfo.transactionType === TRANSACTION_TYPES.JOB_WORK ? charge.postTaxAmount : charge.preTaxAmount),
                        SGST_UTGST: intraState ? getTwoPointNumber(charge.taxPercentage / 2) : '',
                        CGST: intraState ? getTwoPointNumber(charge.taxPercentage / 2) : '',
                        IGST: !intraState ? charge.taxPercentage : '',
                        preTaxAmount: getFormattedCurrency(charge.preTaxAmount)
                    })
                }
            }
            else billingLineItems.push({
                id: charge.id,
                name: charge.name,
                quantity: charge.quantity,
                unitPrice: getFormattedCurrency(charge.unitPrice),
                totalAmount: getFormattedCurrency(charge.postTaxAmount),
                SGST_UTGST: intraState ? getTwoPointNumber(charge.taxPercentage / 2) : '',
                CGST: intraState ? getTwoPointNumber(charge.taxPercentage / 2) : '',
                IGST: !intraState ? charge.taxPercentage : '',
                preTaxAmount: getFormattedCurrency(charge.preTaxAmount)
            })
        })

        const tcs = physicalOrder.taxes?.filter(tax => tax.taxType === TAX_TYPES.TCS)[0]
        if (tcs) {
            billingLineItems.push({
                id: tcs.id,
                name: 'TCS',
                totalAmount: getFormattedCurrency(tcs.taxAmount)
            })
        }

        if (transactionInfo.transactionType === TRANSACTION_TYPES.PURITY_TESTING) {
            const buffingDustWeight = meltingLot.reduce((weight, lot) => lot.buffingDustFine + weight, 0)
            if (buffingDustWeight) {
                billingLineItems.push({
                    id: '3',
                    name: 'Buffing Dust',
                    quantity: -buffingDustWeight + ' gm',
                    totalAmount: getFormattedCurrency(-physicalOrder.buffingDustValue!),
                    unitPrice: getFormattedCurrency(getTwoPointNumber(physicalOrder.buffingDustValue! / buffingDustWeight))
                })
            }
        }
        else if (transactionInfo.transactionType === TRANSACTION_TYPES.MINTED_SALES) {
            physicalOrder.lineItems?.forEach(lineItem => {
                // mintedProducts = {
                //     ...mintedProducts,
                //     quantity: lineItem.quantity + mintedProducts.quantity,
                //     preTaxAmount: getTwoPointNumber((lineItem.unitPrice * lineItem.quantity) + mintedProducts.preTaxAmount),
                //     totalAmount: getTwoPointNumber(lineItem.totalValue + mintedProducts.totalAmount)
                // }
                billingLineItems.push({
                    id: lineItem.id,
                    name: lineItem.product?.product_name || '',
                    quantity: lineItem.quantity,
                    unitPrice: lineItem.unitPrice,
                    totalAmount: getFormattedCurrency(lineItem.totalValue),
                    SGST_UTGST: intraState ? 1.5 : '',
                    CGST: intraState ? 1.5 : '',
                    IGST: !intraState ? 3 : '',
                    preTaxAmount: getFormattedCurrency(getTwoPointNumber(lineItem.unitPrice * lineItem.quantity))
                })
            })

            // if(mintedProducts.totalAmount){
            //     billingLineItems.push({
            //         id:mintedProducts.id,
            //         name: mintedProducts.name,
            //         quantity: mintedProducts.quantity,
            //         totalAmount: getFormattedCurrency(mintedProducts.totalAmount),
            //         taxPercentage: mintedProducts.taxPercentage,
            //         preTaxAmount: getFormattedCurrency(mintedProducts.preTaxAmount)
            //     })
            // }
        }
        else if (transactionInfo.transactionType === TRANSACTION_TYPES.BUY_SELL) {
            let makingCharges = 0
            physicalOrder.charges?.forEach(charge => {
                if (charge.chargeId === CHARGE_TYPES.MAKING_CHARGE) {
                    makingCharges += charge.preTaxAmount
                }
            })

            let customerTakenFineWeight = 0
            for (let lot of meltingLot) {
                customerTakenFineWeight += (lot.customerTakenWeight * (lot.fineness / 1000))
            }

            customerTakenFineWeight = getThreePointNumber(customerTakenFineWeight)

            const buyOrderFineWeight = physicalOrder.lineItems?.reduce((fineWeight, lineItem) => {
                return getThreePointNumber((Number(lineItem.product?.fine_weight) * lineItem.quantity)) + fineWeight
            }, 0) || 0
            let unitPricePrecise = (physicalOrder.preTaxAmount! - makingCharges) / (buyOrderFineWeight + customerTakenFineWeight);
            let unitPrice = getTwoPointNumber(unitPricePrecise);

            physicalOrder.lineItems?.forEach(lineItem => {
                // const lineItemUnitPrice = lineItem.productId === GRAIN_SKU ? (unitPrice / 1000) : unitPrice
                const quantity = getThreePointNumber((lineItem.quantity * Number(lineItem.product?.fine_weight)))
                billingLineItems.push({
                    id: lineItem.id,
                    name: lineItem.product?.product_name || '',
                    quantity: quantity,
                    unitPrice: getFormattedCurrency(unitPrice),
                    totalAmount: getFormattedCurrency(getTwoPointNumber(unitPricePrecise * quantity)),
                    preTaxAmount: getFormattedCurrency(getTwoPointNumber(unitPricePrecise * quantity))
                })
            })

            if (customerTakenFineWeight) {
                billingLineItems.push({
                    id: 'ctw',
                    name: 'Customer Taken Weight',
                    quantity: customerTakenFineWeight,
                    unitPrice: getFormattedCurrency(unitPrice),
                    totalAmount: getFormattedCurrency(getTwoPointNumber(customerTakenFineWeight * unitPricePrecise)),
                    preTaxAmount: getFormattedCurrency(getTwoPointNumber(customerTakenFineWeight * unitPricePrecise))
                })
            }

            const gst = physicalOrder.taxes?.filter(tax => tax.taxType === TAX_TYPES.GST)[0]
            if(gst) {
                if(intraState) {
                        billingLineItems.push({
                        id: gst.id + "_SGST",
                        name:'SGST_UTGST',
                        totalAmount: getFormattedCurrency(getTwoPointNumber(gst.taxAmount / 2))
                    })
                        billingLineItems.push({
                        id: gst.id,
                        name:'CGST',
                        totalAmount: getFormattedCurrency(getTwoPointNumber(gst.taxAmount / 2))
                    })
                }
                else {
                        billingLineItems.push({
                        id: gst.id,
                        name:'IGST',
                        totalAmount: getFormattedCurrency(gst.taxAmount)
                    })
                }
            }
        }
    
        return billingLineItems
    }


    const redirectToIncompleteStep = () => {
        if (prevSection && !capturedSteps.includes(prevSection)) {
            goToPrevSection()
        }
    }

    const goToNextSection = () => {
        if (!capturedSteps.includes('BILLING'))
            return notify('Complete Billing first.', 'error')

        if (id) navigate(path + '/' + id + '?section=' + nextSection)
        else navigate(path + '?section=' + nextSection)
    }

    useEffect(() => {
        if (forceNavigate) {
            goToNextSection()
        }
    }, [forceNavigate])

    const goToPrevSection = () => {
        if (id) navigate(path + '/' + id + '?section=' + prevSection)
        else navigate(path + '?section=' + prevSection)
    }

    // const config = BILLING_CONFIG.map(field => ({...field, value: billingData[field.fieldName as keyof TBilling]}))

    const getBillingDetailsColumns = (): GridColDef<TBilling>[] => {
        let minWidth = 185
        return BILLING_DETAILS_FIELDS.map(billingDetailsField => {
            if( billingDetailsField.id === 'createdAt' ){
                return {
                    field: billingDetailsField.id,
                    headerName: billingDetailsField.label,
                    minWidth:minWidth,
                    renderCell(params) {
                        return <div>{formatDate(params.row.createdAt)}</div>
                    },
                }
            }else{
                return {
                    field: billingDetailsField.id,
                    headerName: billingDetailsField.label,
                    minWidth
                }
            }
        })
    }
    const parseFormattedCurrency = (formattedCurrency: string): number | null => {
        // Remove non-numeric characters and commas
        const numericString = formattedCurrency.replace(/[^\d.-]/g, '');
      
        // Parse the numeric string to tpyeOfInput number
        const parsedNumber = parseFloat(numericString);
      
        // Check if the parsing was successful
        if (!isNaN(parsedNumber)) {
          return parsedNumber;
        } else {
          return null; // Return null if parsing failed
        }
      }

    
    function checkCashPayment(formData : any){
    
       
        if(formData.paymentMethod === 'CASH'){

            let entered_amt=parseFloat(formData.amount)
            let amt=0;
            for(let i = 0 ; i < payments.length ;i++){
                if(payments[i].paymentMethod === 'CASH'){
                    let tpyeOfInput=(typeof(payments[i].amount));
       
                    if(tpyeOfInput==='string'){
                        let amountInNumber=parseFormattedCurrency(payments[i].amount)
                        //@ts-ignore
                        amt += amountInNumber
                     
                       
                    }
                    else{
                    
                      amt +=payments[i].amount
                
                    }
                   
                }
            }
            if((amt + entered_amt )> CASH_TRANSACTION_LIMIT && formData.paymentMethod === 'CASH'){
                return false
            }else{
         

                return true
            }
        }
       
    }

    const submitHandler = async (formData: any) => {
        if( formData.amount <= 0 ){
            return notify(`Amount can not be zero or negative`,'error')
        }
        
        if(Number(billingData.totalBill.replace(/[^0-9.-]+/g, "")) > PAN_LIMIT && customerConfig.kycStatus === 'I') {      
            setShowPanForm(true);
            return  notify(`Pan card required for amount above ${PAN_LIMIT}`, 'error')
        }
        
        let TotalCashAmount = 0
        billingData?.payments?.forEach((pay)=>{
            if(pay.paymentMethod === 'CASH'){
                TotalCashAmount += pay.amount 
               
            }
        })
        if(formData.paymentMethod === 'CASH') 
        TotalCashAmount += +formData.amount

        if(formData.paymentMethod === 'CASH') {
            let totalPaidAmount = 0

            payments.forEach((pay) => {
                if(pay.paymentMethod === 'CASH'){
                    totalPaidAmount += typeof pay.amount === 'number' ? pay.amount : Number(pay.amount.replace(/[^0-9.-]+/g, ""))
                }
            })
           
            if(totalPaidAmount + Number(formData.amount) >= PAN_CASH_LIMIT && customerConfig.kycStatus !== 'Y') {
                setShowPanForm(true);
                return notify(`For cash payment more than ${PAN_CASH_LIMIT} PAN is required.`,'error');
            }
        }

        if(TotalCashAmount >= PAN_CASH_LIMIT && customerConfig.kycStatus !== 'Y') {
            setShowPanForm(true);
            return notify(`For payment more than ${PAN_CASH_LIMIT} PAN is required.`,'error');
        }

        formData.bankName = isBankVisible ? formData.bankName : '';

        
        let cashLimitCheck=  checkCashPayment(formData)
        if(!cashLimitCheck && formData.paymentMethod === 'CASH' ){
            return notify(`Payment amount can't be more than ${CASH_TRANSACTION_LIMIT} Rs.`,'error');
        }

        const isEmployeeOrFnF =customerConfig.userType === 'employee' ||  customerConfig.userType === 'F&F';
        console.log('isEmployeeOrFnF', isEmployeeOrFnF, 'isEmployeeVerified', isEmployeeVerified)

        if (isEmployeeOrFnF && !isEmployeeVerified) {

            const { data, error } = await execute(() =>
                sendOtpForEmployeeValidation({
                    dgCustomerRefNo: customerConfig.dgCustomerRefNo!
                })
            );

            if (error === null && data?.status === 'ok') {
                setOtpSentTo(data.otpSentTo);
                setOpenEmployeeValidationModal(true);
                setPendingBillingFormData(formData);
            }

            return;
        }
        const payload = {
            global_transaction_number: globalTransactionNumber,
            payment_type: "INBOUND",
            payment_status: "PAID",
            billing_number: billingData.id,
            transactionType: transactionInfo.transactionType,
            ...formData
        }
        // if( formData.amount > customerConfig.walletBalance && formData.paymentMethod === "WALLET" && transactionInfo.transactionType != TRANSACTION_TYPES.BUY_SELL ){
        if( formData.amount > customerConfig.walletBalance && formData.paymentMethod === "WALLET" ){
            return notify(`Amount can't be more than Available Wallet Balance`,'error');
        }
        if (formData.amount > billingData.totalPending) {
            notify(`Payment Amount can't be more than total pending amount.`, 'error');
        } else {
            setLoading(true)
            const { data, error } = await execute(() => recordBillingPayment(payload));
            setLoading(false)
            if(data !== null){
                notify(`Payment created successfully`);
                // if (data?.order.status) {
                //     setShowPaymentForm(false);
                //     notify('Billing Settle Successfully');
                //     setCapturedSteps(prev => ([...prev, 'BILLING']));
                //     setForceNavigate(true);
                // }
                setFormData({} as TPayment);
            }
        }
    }
    const onBillingOtpClose = async (success?: boolean) => {
        setOpenEmployeeValidationModal(false);

        if (success) {
            setIsEmployeeVerified(true);
        }
    };

    useEffect(() => {
    if (isEmployeeVerified && pendingBillingFormData) {

        const formData = pendingBillingFormData;

        setPendingBillingFormData(null);

        submitHandler(formData);
    }
}, [isEmployeeVerified]);

    const confirmPayments = async() => {
        setIsButtonDisabled(true);
        const {error} = await execute(()=>confirmBillingPayments({
            globalTransactionNumber:globalTransactionNumber,
            transactionType:transactionInfo.transactionType
        }))
        if(error) setIsButtonDisabled(false);
        if(error === null){
            setShowPaymentForm(false);
            setCapturedSteps(prev => ([...prev, 'BILLING']));
            setForceNavigate(true);
        }
    }
    const getPaymentsColumns = () => {
        // for(let i = 0 ; i <payments.length ; i++){
        //     const originalDateString =  payments[i].createdAt;
        //     payments[i].createdAt = moment(originalDateString).format('DD-MMM-YYYY');
        // }
        return PAYMENT_COLUMNS.map(column => {
            if(column.field === 'actions') {
                column.renderCell = (params) => {
                    return transactionInfo.status === TRANSACTION_STATUS.PAYMENT_INITIATED ? <>
                        <Tooltip title="Delete Payment">
                            <IconButton 
                            disabled={params.row.paymentMethod === "BUYSELL_TRANSACTION_SETTLEMENT" || params.row.paymentMethod === "TDS_SETTLEMENT"}
                            color='error'
                            onClick={() =>{
                                confirm({
                                    handleConfirm: () => execute(() => deleteBillingPayment({
                                        globalTransactionNumber: globalTransactionNumber!,
                                        transactionType: transactionInfo.transactionType,
                                        paymentId: params.row.id
                                    })),
                                    text: 'Are you sure you want to delete this payment?',
                                    title: 'Delete Payment'
                                })
                            }}>
                                <Delete />
                            </IconButton>
                        </Tooltip>
                    </> : <></>
                }
            } else if(column.field === 'createdAt') {
                column.renderCell = params => params.row.createdAt ? moment(params.row.createdAt).format('DD-MMM-YYYY') : "NA"
            }

            return column
        })
    }

    const configureForm = () => {
        let paymentOptions = PAYMENT_OPTIONS
        
        // if(transactionInfo.transactionType === TRANSACTION_TYPES.BUY_BACK) {
        //     paymentOptions = PAYMENT_OPTIONS.filter(option => option.value != 'WALLET')
        // }

        setFormConfig(prev => {
            return prev.map(field =>{
                if(field.fieldName === 'paymentMethod') field = {...field, options:paymentOptions}
                if(field.fieldName === 'proofOfPayment') field = {...field, RenderField: UploadFile}
                return field
            })
        })
    }

    useEffect(() => {
        redirectToIncompleteStep()
        if(transactionInfo.transactionType && transactionInfo.transactionType != TRANSACTION_TYPES.MINTED_SALES)execute(() => getLotDetails({ globalTransactionNumber }))
        configureForm()
        getBankOptions()
    }, [])

    useEffect(()=>{
        let paymentOptions = transactionInfo.transactionType == "BUY_BACK" 
        ? PAYMENT_OPTIONS.filter(option => option.value !== "WALLET")
        : PAYMENT_OPTIONS

        function optionsContainsRazorPay(array : any, value : string) {
            return array.some((option : any)  => Object.values(option).includes(value));
        }
        if(transactionInfo.transactionType == "BUY_BACK"){
            if( !(optionsContainsRazorPay(paymentOptions, 'RAZORPAY'))){
                let razorpayMethodOption = { value: 'RAZORPAY', label: 'Razorpay'}
                paymentOptions.push(razorpayMethodOption)
            }
        }else{
            paymentOptions = paymentOptions.filter(option => option.value !== 'RAZORPAY' && option.label !== 'Razorpay');
        }
        if(payments.filter(payment => payment.paymentMethod === 'WALLET').length) {
            paymentOptions = PAYMENT_OPTIONS.filter(option => option.value != 'WALLET')
        }
        setField('paymentMethod', {options: paymentOptions})
    },[payments])
    
    const ClosePanForm = () => {
        setShowPanForm(false)
    }
    
    const fetchCustomer = () => execute(()=> getCustomer({customerRefNo:customerConfig.customerRefNo!}))

    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8', display:'flex', alignItems:'center',justifyContent:"space-between" }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Billing/Payment Details</Title>
                {[TRANSACTION_TYPES.BUY_BACK].includes(transactionInfo.transactionType)?
                <DownloadInvoice
                        fileName={transactionInfo.globalTransactionNumber!}
                        label={transactionInfo.transactionType === TRANSACTION_TYPES.BUY_BACK ? 'Download Purchase Receipt' : 'Download Invoice'}
                    /> : <></> }
               {![TRANSACTION_TYPES.BUY_BACK, TRANSACTION_TYPES.GMS].includes(transactionInfo.transactionType) ?
               <Tooltip title='More Info'>
                    <IconButton style={{marginTop:'10px'}} size='small' onClick={() => setShowBillingModal(true)} ><Info /></IconButton>
                </Tooltip> :
                <></>}
            </div>
            {transactionInfo.transactionType === TRANSACTION_TYPES.MINTED_SALES && capturedSteps[1] === 'BILLING' ?
                <></>
                :
                <div style={{ padding: '20px 0px' }}>
                    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 0', color: '#7f7d76' }}>Billing Details</Title>
                    <Table columns={getBillingDetailsColumns()} rows={billingData && Object.keys(billingData).length ? [billingData] : []} />
                </div>
            }
            <div style={{fontSize:"2rem",width:"100%",display:"flex", justifyContent:"flex-end"}}>
                <div style={{display:"flex",flexDirection:'column', border:"1px solid silver",borderRadius:"6px", overflow:'hidden'}}>
                    <Typography sx={{fontSize:'14px', padding:'5px', background:'#f1f1f1'}}>Available Balance</Typography>
                    <Typography sx={{color:"green", fontSize:'14px', padding:'5px', fontWeight:'bold'}}>{getFormattedCurrency((customerConfig.walletBalance || 0), true)}</Typography>
                </div>
            </div>
            {billingData.totalPending ?
                <div style={{ padding: '0 0 20px 0' }}>
                    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 0', color: '#7f7d76' }}>Create Payments</Title>
                    {loading ? <FormSkeleton /> : <DynamicFormNew {...registerForm()} onSubmit={submitHandler} submitText='Create Payment' />}
                </div> : 
                <></>
            }

            <div style={{ overflow: 'hidden' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 0', color: '#7f7d76' }}>Payments</Title>
                <Table 
                columns={getPaymentsColumns()} 
                rows={payments} 
                initialState={{ sorting: { sortModel: [{ field: 'createdAt', sort: 'desc' }] }, columns:{ columnVisibilityModel: {actions:transactionInfo.status === TRANSACTION_STATUS.PAYMENT_INITIATED}} }}
                />
                {!billingData.totalPending && transactionInfo.status === TRANSACTION_STATUS.PAYMENT_INITIATED ? 
                <Button onClick={confirmPayments} disabled = {isButtonDisabled} variant='contained' sx={{mt:'10px'}}>
                    {getConfirmPaymentsLabel(transactionInfo.transactionType)}
                </Button> :
                 <></>}
            </div>

            {transactionInfo.transactionType !== TRANSACTION_TYPES.MINTED_SALES &&
                <div style={{ marginTop: '20px' }}>
                    <StepNavigation
                        capturedSteps={capturedSteps}
                        currentSection='BILLING'
                        goToNextSection={goToNextSection}
                        nextButtonLable={nextButtonLable}
                        goToPrevSection={goToPrevSection}
                        prevSection={prevSection}
                    />
                </div>
            }
            <Modal open={Boolean(showPanForm)} title={'Upload PAN'} onClose={ClosePanForm}>
                <CustomerPanUpload customerDetail={customerConfig as ICustomerSummary} modalClose={() => setShowPanForm(false)} onSuccess={fetchCustomer} />
            </Modal>
            <BillingDetailsModal 
                open={showBillingModal}
                onClose={() => setShowBillingModal(false)}
                lineItems={getBillingLineItems() || []}
            />
            <EmployeeValidationModal
                open={openEmployeeValidationModal}
                onClose={onBillingOtpClose}
                dgCustomerRefNo={customerConfig.dgCustomerRefNo!}
                phone={otpSentTo}
            />
        </div>
    )
}

function getConfirmPaymentsLabel(transactionType:string){
    switch (transactionType) {
        case TRANSACTION_TYPES.BUY_BACK:
            return 'Generate Receipt'
    
        case TRANSACTION_TYPES.PURITY_TESTING:
        case TRANSACTION_TYPES.MINTED_SALES:
            return 'Generate Invoice'
        
        default:
            return 'Confirm Payments'
    }
}

export default Billing
